import axios, { AxiosRequestConfig } from 'axios';

// API base URL - uses relative path in production, explicit localhost in development
export const API_BASE_URL =
  process.env.NODE_ENV !== 'production' ? 'http://localhost:5001/api' : '/api';

// Create axios instance with default config
export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

export const getSessionToken = () => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('stytch_session='))
    ?.split('=')[1];
};

// Add request interceptor to include auth token
axiosInstance.interceptors.request.use((config) => {
  // Get the session token from cookies directly since Stytch stores it there
  const sessionToken = getSessionToken();
  if (sessionToken) {
    config.headers.Authorization = `Bearer ${sessionToken}`;
  }
  return config;
});

interface RequestOptions extends Omit<AxiosRequestConfig, 'url' | 'baseURL'> {
  params?: Record<string, string>;
}

/**
 * Helper function to make authenticated API requests
 * Automatically includes auth token from session and handles common response patterns
 */
export const apiRequest = async <T>(endpoint: string, options: RequestOptions = {}): Promise<T> => {
  try {
    const isFormData = options.data instanceof FormData;
    const headers = isFormData
      ? { ...options.headers } // Don't set Content-Type, let browser/axios handle it
      : { 'Content-Type': 'application/json', ...options.headers };

    const response = await axiosInstance({
      url: endpoint,
      ...options,
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(`API request error for ${endpoint}:`, error);
    throw error;
  }
};
